// What a code gives: the perk a new payer gets, and a creator's deal. Plain words from a few numbers,
// shared by the server and the pages so every screen says it the same way.

export interface Deal { freeSplits?: number; revSharePct?: number; rewardSplits?: number; payerCap?: number }

/** "No subscription. No fee on the first split", or '' for no perk. */
export const perkText = (freeSplits: number) => (freeSplits <= 0 ? '' : freeSplits === 1 ? 'No subscription. No fee on the first split' : `No subscription. No fee on the first ${freeSplits} splits`);

/** A creator's deal in one line: "50% of the fee on the first 5 paid splits of every new payer, for the first 100". */
export function creatorTerms(c: Deal): string {
  const n = c.rewardSplits ?? 1;
  const splits = n === 1 ? 'first paid split' : `first ${n} paid splits`;
  return `${c.revSharePct ?? 50}% of the fee on the ${splits} of every new payer${c.payerCap ? `, for the first ${c.payerCap} new payers` : ''}`;
}

/** The most a creator's link can ever earn them, in cents, at a given net fee. Null when payers aren't capped. */
export const creatorMaxCents = (c: Deal, feeNetCents: number) =>
  c.payerCap ? Math.round((c.payerCap * (c.rewardSplits ?? 1) * feeNetCents * (c.revSharePct ?? 50)) / 100) : null;
